/*
 * MarketPage Messages
 *
 * This contains all the text for the MarketPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LandingPage.FarmToTablePage';

export default defineMessages({
  pageTitleText: {
    id: `${scope}.pageTitleText`,
    defaultMessage: 'Từ nông trại đến doanh nghiệp,{break}tươi ngon, ổn định mỗi ngày',
  },
  pageSubText: {
    id: `${scope}.pageSubText`,
    defaultMessage:
      'Hơn 3.000 doanh nghiệp F&B đã lựa chọn {break} nguồn thực phẩm tươi trực tiếp từ nông trại cùng Kamereo.',
  },
  exploreVeggiesResource: {
    id: `${scope}.exploreVeggiesResource`,
    defaultMessage: 'Khám phá sản phẩm',
  },
  sloganSubtext1: {
    id: `${scope}.sloganSubtext1`,
    defaultMessage:
      'Từ những luống rau xanh mướt ở Đà Lạt và miền Tây, Kamereo kết nối trực tiếp với người nông dân – không qua trung gian. Nhờ vậy, rau củ đến tay bạn luôn tươi mới, rõ nguồn gốc và có mức giá ổn định. Một hành trình ngắn hơn, chất lượng hơn – để mỗi bữa ăn thêm an tâm.',
  },
  sloganSubtext2: {
    id: `${scope}.sloganSubtext2`,
    defaultMessage: 'Kamereo kết nối trực tiếp với nông dân để bạn yên tâm về chất lượng, độ tươi và giá cả ổn định.',
  },
  productSourceTitle: {
    id: `${scope}.productSourceTitle`,
    defaultMessage: 'Cách Kamereo',
  },
  productSourceHighlightTitle: {
    id: `${scope}.productSourceHighlightTitle`,
    defaultMessage: 'kết nối nông trại với doanh nghiệp',
  },
  seeMore: {
    id: `${scope}.seeMore`,
    defaultMessage: 'Xem thêm ({count})',
  },
  collapse: {
    id: `${scope}.collapse`,
    defaultMessage: 'Thu gọn',
  },
  VEGETABLE_FARM: {
    id: `${scope}.VEGETABLE_FARM`,
    defaultMessage: 'Rau lá',
  },
  LETTUCE_FARM: {
    id: `${scope}.LETTUCE_FARM`,
    defaultMessage: 'Xà lách',
  },
  HERBS_FARM: {
    id: `${scope}.HERBS_FARM`,
    defaultMessage: 'Rau gia vị',
  },
  MUSHROOM_FARM: {
    id: `${scope}.MUSHROOM_FARM`,
    defaultMessage: 'Nấm tươi',
  },
  seeAll: {
    id: `${scope}.seeAll`,
    defaultMessage: 'Xem tất cả',
  },
  ourStory: {
    id: `${scope}.ourStory`,
    defaultMessage: 'Câu chuyện',
  },
  productCategory: {
    id: `${scope}.productCategory`,
    defaultMessage: 'Danh mục sản phẩm',
  },
  process: {
    id: `${scope}.process`,
    defaultMessage: 'Quy trình',
  },
  benefits: {
    id: `${scope}.benefits`,
    defaultMessage: 'Lợi ích',
  },
  partners: {
    id: `${scope}.partners`,
    defaultMessage: 'Đối tác F&B',
  },
  contactUs: {
    id: `${scope}.contactUs`,
    defaultMessage: 'Liên hệ',
  },
  become: {
    id: `${scope}.become`,
    defaultMessage: 'Trở thành',
  },
  kamereoCustomer: {
    id: `${scope}.kamereoCustomer`,
    defaultMessage: 'đối tác của Kamereo',
  },
  kamereoCustomerDescription: {
    id: `${scope}.kamereoCustomerDescription`,
    defaultMessage:
      'Hàng ngàn nhà hàng và quán ăn đã tối ưu quy trình vận hành, tiết kiệm chi phí nhờ mô hình “Từ nông trại đến doanh nghiệp”. Để lại thông tin – Kamereo sẵn sàng đồng hành cùng bạn từ những bước đầu tiên.',
  },
  contactUsSuccess: {
    id: `${scope}.contactUsSuccess`,
    defaultMessage: 'Đã liên hệ thành công',
  },
  playVideo: {
    id: `${scope}.playVideo`,
    defaultMessage: 'Hành trình của sự tươi ngon',
  },
  purchase: {
    id: `${scope}.purchase`,
    defaultMessage: 'Thu mua nông sản {break} từ các nông trại hợp tác',
  },
  transport: {
    id: `${scope}.transport`,
    defaultMessage: 'Vận chuyển bằng xe tải lạnh',
  },
  allocation: {
    id: `${scope}.allocation`,
    defaultMessage: 'Phân phối tại các trung tâm {break} điều phối chiến lược',
  },
  preservation: {
    id: `${scope}.preservation`,
    defaultMessage: 'Bảo quản bằng phòng mát chuyên biệt',
  },
  qualityControl: {
    id: `${scope}.qualityControl`,
    defaultMessage: 'Kiểm tra, phân loại và {break} vận chuyển đến khách hàng',
  },
  contact: {
    id: `${scope}.contact`,
    defaultMessage: 'Liên hệ',
  },
  registerNow: {
    id: `${scope}.registerNow`,
    defaultMessage: 'Đăng ký ngay',
  },
  aboutUs: {
    id: `${scope}.aboutUs`,
    defaultMessage: 'Về chúng tôi',
  },
  explorerMore: {
    id: `${scope}.explorerMore`,
    defaultMessage: 'Trang chủ',
  },
  registerSuccess: {
    id: `${scope}.registerSuccess`,
    defaultMessage: 'Đăng ký thành công!',
  },
  subTextContact: {
    id: `${scope}.subTextContact`,
    defaultMessage:
      'Chúng tôi đã nhận được thông tin của bạn. Đội ngũ chăm sóc khách hàng sẽ liên hệ với bạn {workingTime}',
  },
  subTextContactBelow: {
    id: `${scope}.subTextContactBelow`,
    defaultMessage: 'Nếu bạn cần hỗ trợ gấp? Gọi ngay ',
  },
  workingTime: {
    id: `${scope}.workingTime`,
    defaultMessage: 'trong vòng 24h làm việc.',
  },
  learnMoreUs: {
    id: `${scope}.learnMoreUs`,
    defaultMessage: 'Khám phá thêm về Kamereo',
  },
  sendInfo: {
    id: `${scope}.sendInfo`,
    defaultMessage: 'Gửi thông tin',
  },
  kamereoPartner: {
    id: `${scope}.kamereoPartner`,
    defaultMessage: 'một phần của hành trình',
  },
  sustainableBusiness: {
    id: `${scope}.sustainableBusiness`,
    defaultMessage: 'doanh nghiệp F&B bền vững',
  },
  bannerSubtextLoggin: {
    id: `${scope}.bannerSubtextLoggin`,
    defaultMessage: 'Những sản phẩm thiết yếu tại Kamereo được hàng ngàn doanh nghiệp F&B tại Việt Nam tin dùng.',
  },
  bannerSubtextNonLoggin: {
    id: `${scope}.bannerSubtextNonLoggin`,
    defaultMessage: 'Đăng ký ngay để nhận được giá tốt hơn và ưu đãi riêng cho doanh nghiệp F&B.',
  },
  bannerFreeShip: {
    id: `${scope}.bannerFreeShip`,
    defaultMessage: 'Giao miễn phí từ 400.000đ',
  },
  bannerReturn: {
    id: `${scope}.bannerReturn`,
    defaultMessage: 'Đổi trả trong ngày',
  },
  bannerConvenientOrder: {
    id: `${scope}.bannerConvenientOrder`,
    defaultMessage: 'Đặt hàng nhanh chóng',
  },
  bannerFresh: {
    id: `${scope}.bannerFresh`,
    defaultMessage: 'Tươi ngon 100%',
  },
  getProductConsultation: {
    id: `${scope}.getProductConsultation`,
    defaultMessage: 'Nhận tư vấn',
  },
  purchaseFromFavorite: {
    id: `${scope}.purchaseFromFavorite`,
    defaultMessage: 'Mua lại từ yêu thích',
  },
  purchaseFromKamereoLabel: {
    id: `${scope}.purchaseFromKamereoLabel`,
    defaultMessage: 'Khám Phá Thương Hiệu Kamereo',
  },
  viewDetail: {
    id: `${scope}.viewDetail`,
    defaultMessage: 'Xem chi tiết',
  },
});
